import styled from 'styled-components';

import LockedIcon from 'components/icons/locked';

export const LockedOfferContainer = styled.div`
  width: 60px;
  height: 60px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 100%;
  z-index: ${Styles.zIndex.top};
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const StyledLock = styled(LockedIcon)`
  width: 2.5rem;
  height: 2.5rem;
  top: 50%;
  left: 50%;
  border-radius: 2px;
`;
